import {
  Component,
  OnInit,
  EventEmitter,
  Input,
  ViewChildren,
  Output,
  Renderer2,
  PLATFORM_ID,
  inject,
} from '@angular/core';
import { ThemeService } from '../../services/theme.service';
import { LayoutService } from '../../services/layout.service';
import { TranslateService } from '@ngx-translate/core';
import { JwtAuthService } from '../../services/auth/jwt-auth.service';
import { EgretNotifications2Component } from '../egret-notifications2/egret-notifications2.component';
import { ServiceCookie } from 'app/shared/services/cookie.service';
import { Router } from '@angular/router';
import { KeycloakAuthService } from 'app/shared/services/keycloak/keycloak-auth.service';
import { isPlatformBrowser } from '@angular/common';
@Component({
    selector: 'app-header-side',
    templateUrl: './header-side.template.html',
    standalone: false
})
export class HeaderSideComponent implements OnInit {
  private readonly platformId = inject(PLATFORM_ID);

  @Input() notificPanel;
  @ViewChildren(EgretNotifications2Component) noti;
  public availableLangs = [
    {
      name: 'EN',
      code: 'en',
      flag: 'us',
    },
    {
      name: 'ES',
      code: 'es',
      flag: 'es',
    },
  ];
  currentLang = this.availableLangs[0];

  public egretThemes;
  public username =
    JSON.parse(localStorage.getItem('user'))?.userInfo?.preferred_username ||
    '';
  public imgProfile: string =
    JSON.parse(localStorage.getItem('user') || '{}').userInfo.picture ||
    'assets/images/face-7.jpg';
  public layoutConf: any;
  constructor(
    private themeService: ThemeService,
    private layout: LayoutService,
    public translate: TranslateService,
    private renderer: Renderer2,
    public jwtAuth: JwtAuthService,
    private router: Router,
    private keycloakAuthService: KeycloakAuthService,
  ) {}
  ngOnInit() {
    this.egretThemes = this.themeService.egretThemes;
    this.layoutConf = this.layout.layoutConf;
    this.translate.use(this.currentLang.code);
  }
  setLang(lng) {
    this.currentLang = lng;
    this.translate.use(lng.code);
  }
  changeTheme(theme) {
    // this.themeService.changeTheme(theme);
  }
  toggleNotific() {
    // this.notificPanel.toggle();
  }
  toggleSidenav() {
    if (this.layoutConf.sidebarStyle === 'closed') {
      return this.layout.publishLayoutChange({
        sidebarStyle: 'full',
      });
    }
    this.layout.publishLayoutChange({
      sidebarStyle: 'closed',
    });
  }

  toggleCollapse() {
    // compact --> full
    if (this.layoutConf.sidebarStyle === 'compact') {
      return this.layout.publishLayoutChange(
        {
          sidebarStyle: 'full',
          sidebarCompactToggle: false,
        },
        { transitionClass: true },
      );
    }

    // * --> compact
    this.layout.publishLayoutChange(
      {
        sidebarStyle: 'compact',
        sidebarCompactToggle: true,
      },
      { transitionClass: true },
    );
  }

  onSearch(e) {}
  logOut() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.keycloakAuthService.logout();
  }
  goToHome() {
    this.keycloakAuthService.getValidToken(-1).then((token) => {
      if (token) {
        this.router.navigate(['/dashboard/default']);
      } else {
        this.keycloakAuthService.login();
      }
    });
  }
  changePasswordWithKeyCloak() {
    this.keycloakAuthService.changePassword();
  }
  profile() {
    // this.router.navigate(['/profile/settings']);
    //https://myaccount.hanuman.com.kh/dashboard/default
    window.open('https://myaccount.hanuman.com.kh/dashboard/default', '_blank');
  }
}
